import { render, staticRenderFns } from "./sup-payment-method.vue?vue&type=template&id=5f437942"
import script from "./sup-payment-method.vue?vue&type=script&lang=js"
export * from "./sup-payment-method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports